import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';

const RenNumber = ({ data, accessor, columnData }) => {
  const { secondary = true } = columnData;

  return (
    <div className={clsx('tbl-ren-number', { secondary })}>
      {data[accessor]}
    </div>
  );
};

RenNumber.defaultProps = {
  data: {},
  columnData: {},
};

RenNumber.propTypes = {
  id: PropTypes.string.isRequired,
  accessor: PropTypes.string.isRequired,
  data: PropTypes.shape(),
  columnData: PropTypes.shape({
    secondary: PropTypes.bool,
  }),
};

export default RenNumber;
